module.exports = "<p>The artist on<br><em>A la belle étoile (Under The Sky)</em> 2007</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room6/audio1/content.md
// module id = 845
// module chunks = 0